var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon svg-icon-approve",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.435 1.99L1.212 14.225a1.979 1.979 0 0 0 .04 1.858c.32.569.9.917 1.526.917h12.444a1.76 1.76 0 0 0 1.526-.917c.321-.57.336-1.274.04-1.858L10.565 1.99C10.255 1.38 9.655 1 9 1c-.654 0-1.255.38-1.565.99zm7.33 12.11c.252.497.014.9-.54.9H3.775c-.55 0-.79-.407-.54-.9L9 2.765 14.765 14.1z",
    fill: "#E6C543",
    stroke: "#E6C543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10c0 .552.444 1 1 1 .552 0 1-.444 1-1V7c0-.552-.444-1-1-1-.552 0-1 .444-1 1v3zm1 4c.552 0 1-.444 1-1 0-.552-.444-1-1-1-.552 0-1 .444-1 1 0 .552.444 1 1 1z",
    fill: "#969EA7",
    stroke: "#969EA7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fbfc38e126127b53c1ea17e9e6bc57f3.svg";
export { ForwardRef as ReactComponent };